import { createApp } from 'vue';
import axios from 'axios';
import Notifications from '@kyvg/vue3-notification';

import App from '@/App.vue';
import store from '@/store';
import router from '@/router';
import vuetify from '@/plugins/vuetify';

import { sortable } from '@/lib/globalRegistrations';
import { FatalErrorException } from '@/lib/exceptions';
import { beforeInterceptor, beforeResolveInterceptor } from '@/lib/routerConfig';
import {
  requestConfig,
  requestError,
  responseConfig,
  responseError,
} from '@/lib/axiosConfig';


const app = createApp(App);

// Directives, filters, etc
axios.interceptors.request.use(requestConfig, requestError);
axios.interceptors.response.use(responseConfig, responseError);

app.config.productionTip = false;

app.directive('sortable', sortable);

router.beforeEach(beforeInterceptor);
router.beforeResolve(beforeResolveInterceptor);


// Global error handling
const handleFatalError = (err) => {
  store.dispatch('notify/toggleFatalErrorModal', {
    title: 'Fatal Error',
    text: 'Please attempt to reproduce this error and contact support.',
    errorMessage: err.message,
    bool: true,
  });
};

// We'll eventually need to handle errors from 3 places:
// (See https://stackoverflow.com/questions/52071212/how-to-implement-global-error-handling-in-vue)
/*
Vue.config.errorHandler = (err, vm, info) => {
  // `info` is a Vue-specific error info, e.g. which lifecycle hook
  // the error was found in.
};
window.onerror = (msg, url, line, col, error) => {
  // code to handle non-Vue js error goes here
};
*/
window.addEventListener('unhandledrejection', (event) => {
  // handle error in promise here
  // event.promise contains the promise object
  // event.reason contains the reason for the rejection
  if (event.reason instanceof FatalErrorException) {
    handleFatalError(event.reason);
  }
});


app.use(vuetify);
app.use(store);
app.use(router);
app.use(Notifications);

app.mount('#app');
